module.exports = __webpack_public_path__ + "img/expostyle_1083_bright_canary_yellow_pantone108c.26a79107.jpg";